<!--企业年报详情-->
<template>
  <div class="annualReport" :style="'min-height:'+heightH+'px'">
    <header-index/>
    <div class="basic-content">
      <div class="basic-details-breadcrumb">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
          <el-breadcrumb-item :to="{ path: '/ServiceCentre/serviceCloud?pName='+cityList.abridge+'企服务云' }">
            {{ cityList.abridge }}企服务云
          </el-breadcrumb-item>
          <el-breadcrumb-item :to="{ path: '/enterpriseSearch/index' }">企业查询</el-breadcrumb-item>
          <el-breadcrumb-item><a @click="back">企业详情</a></el-breadcrumb-item>
          <el-breadcrumb-item>企业年报详情</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <el-row class="basic-details" :style="'height:'+heightL+''">
        <el-row class="enterpriseBase" style="background: white;padding-bottom:20px;">
          <el-col :span="24">
            <div class="demo-basic--circle" style="float: left;padding: 30px;">
              <div class="block">
                <el-avatar shape="square" fit="scale-down" style="width: 170px;height: 170px;" :src="basicInfo.companyLogo"
                           v-if="basicInfo.companyLogo!=null && basicInfo.companyLogo!='https://aiqicha.baidu.com//static/pc/photo/logo.png' && basicInfo.companyLogo!='http://aiqicha.baidu.com//static/pc/photo/logo.png' && basicInfo.companyLogo!='https://aiqicha.baidu.com/static/pc/photo/logo.png' && basicInfo.companyLogo!='http://aiqicha.baidu.com/static/pc/photo/logo.png'"/>
                <el-avatar shape="square" fit="scale-down" v-else style="width: 170px;height: 170px">
                  <div class="logo-keyword" :style="'background:'+createRandomColor()+''" v-if="basicInfo.entLogoWord!='' && basicInfo.entLogoWord!=null">
                    <span v-for="(logo,index) of logoword(basicInfo.entLogoWord)" class="logo-word"v-if="index<4">{{ logo }}</span>
                  </div>
                  <div class="logo-keyword" :style="'background:'+createRandomColor()+''" v-else>
                    <span v-for="(l,index) of logoword(basicInfo.companyName)" class="logo-word" v-if="index<4">{{ l }}</span>
                  </div>
                </el-avatar>
              </div>
            </div>
            <div class="userName">{{ basicInfo.companyName }}</div>
            <div class="small-info" style="padding-top: 10px;">统一社会信用代码：{{ basicInfo.unifiedSocialCreditCode || '-' }}</div>
            <div class="small-info">法定代表人：{{ basicInfo.name || '-' }}</div>
            <div class="small-info">登记机关：{{ basicInfo.registrationAuthority  || '-'}}</div>
            <div class="small-info">成立日期：{{ basicInfo.establishTime || '-' }}</div>
          </el-col>
        </el-row>
        <!--企业年报-->
        <el-row class="baseType" style="background: white;margin-top: 10px;">
          <div class="cols-1" style="background: #F5F5F5;">企业年报</div>
          <div style="font-size: 20pt;color: #333333;font-weight: normal;text-align: center;padding: 30px 0px 30px;">
            {{ annualReportsInfo.title }}
          </div>
          <div class="cols-1" style="font-weight: bold;">企业基本信息</div>
          <div class="col-i">
            <el-row>
              <el-col :span="5" class="col-1">统一社会信用代码/注册号</el-col>
              <el-col :span="7" class="col-2" v-if="annualReportsInfo.essentialInformation">{{ annualReportsInfo.essentialInformation.creditCode }}</el-col>
              <el-col :span="7" class="col-2" v-else>-</el-col>
              <el-col :span="5" class="col-1">企业名称</el-col>
              <el-col :span="7" class="col-2" v-if="annualReportsInfo.essentialInformation">{{ annualReportsInfo.essentialInformation.companyName }}</el-col>
              <el-col :span="7" class="col-2"v-else></el-col>
            </el-row>
            <el-row>
              <el-col :span="5" class="col-1">企业联系电话</el-col>
              <el-col :span="7" class="col-2" v-if="annualReportsInfo.essentialInformation">{{ annualReportsInfo.essentialInformation.contactNumber }}</el-col>
              <el-col :span="7" class="col-2" v-else>-</el-col>
              <el-col :span="5" class="col-1">邮政编码</el-col>
              <el-col :span="7" class="col-2" v-if="annualReportsInfo.essentialInformation">{{ annualReportsInfo.essentialInformation.postalCode }}</el-col>
              <el-col :span="7" class="col-2" v-else></el-col>
            </el-row>
            <el-row>
              <el-col :span="5" class="col-1">企业经营状态</el-col>
              <el-col :span="7" class="col-2" v-if="annualReportsInfo.essentialInformation">{{ annualReportsInfo.essentialInformation.businessStatus }}</el-col>
              <el-col :span="7" class="col-2" v-else>-</el-col>
              <el-col :span="5" class="col-1">从业人数</el-col>
              <el-col :span="7" class="col-2" v-if="annualReportsInfo.essentialInformation">{{ annualReportsInfo.essentialInformation.practiceNumber }}</el-col>
              <el-col :span="7" class="col-2" v-else></el-col>
            </el-row>
            <el-row>
              <el-col :span="5" class="col-1">电子邮箱</el-col>
              <el-col :span="7" class="col-2" v-if="annualReportsInfo.essentialInformation">{{ annualReportsInfo.essentialInformation.email }}</el-col>
              <el-col :span="7" class="col-2" v-else>-</el-col>
              <el-col :span="5" class="col-1">是否有网站或网店</el-col>
              <el-col :span="7" class="col-2" v-if="annualReportsInfo.essentialInformation">{{ annualReportsInfo.essentialInformation.websitesOnlineShop }}</el-col>
              <el-col :span="7" class="col-2" v-else>-</el-col>
            </el-row>
            <el-row>
              <el-col :span="5" class="col-1" style="height: 80px;">企业通信地址</el-col>
              <el-col :span="7" class="col-2" style="height: 80px;" v-if="annualReportsInfo.essentialInformation">{{annualReportsInfo.essentialInformation.address}}</el-col>
              <el-col :span="7" class="col-2" v-else>-</el-col>
              <el-col :span="5" class="col-1" style="height: 80px;">企业是否有投资信息或购买其他公司股权</el-col>
              <el-col :span="7" class="col-2" style="height: 80px;" v-if="annualReportsInfo.essentialInformation">{{ annualReportsInfo.essentialInformation.haveInvestmentInformationPurchase }}</el-col>
              <el-col :span="7" class="col-2" v-else>-</el-col>
            </el-row>
          </div>
          <div class="cols-1" style="font-weight: bold;">网站或网店信息</div>
          <div class="col-i">
            <el-table :data="annualReportsInfo.onlineShopWebsiteInformation" style="width: 100%" border
                      :header-row-style="{background:'#F3F9FC'}">
              <el-table-column type="index" label="序号" width="50" align="center"></el-table-column>
              <el-table-column prop="type" label="类型" align="center"></el-table-column>
              <el-table-column prop="name" label="名称" align="center"></el-table-column>
              <el-table-column prop="website" label="网址" align="center"></el-table-column>
            </el-table>
          </div>
          <div class="cols-1" style="font-weight: bold;">股东及出资信息</div>
          <div class="col-i">
            <el-table :data="annualReportsInfo.shareholderContributionInformation" style="width: 100%" border
                      :header-row-style="{background:'#F3F9FC'}">
              <el-table-column type="index" label="序号" width="50" align="center"></el-table-column>
              <el-table-column prop="name" label="股东"></el-table-column>
              <el-table-column prop="subscribedCapitalContribution" label="认缴出资额"></el-table-column>
              <el-table-column prop="subscribedCapitalContributionTime" label="认缴出资日期" width="130"></el-table-column>
              <el-table-column prop="subscribedCapitalContributionMode" label="认缴出资方式" width="140"></el-table-column>
              <el-table-column prop="capitalContributionPaid" label="实缴出资额"></el-table-column>
              <el-table-column prop="capitalContributionPaidTime" label="实缴出资日期" width="130"></el-table-column>
              <el-table-column prop="capitalContributionMethod" label="实缴出资方式" width="140"></el-table-column>
            </el-table>
          </div>
          <div class="cols-1" style="font-weight: bold;">企业资产状况信息</div>
          <div class="col-i" v-if="annualReportsInfo.assetsStatus">
            <el-row>
              <el-col :span="5" class="col-1">资产总额</el-col>
              <el-col :span="7" class="col-2" v-if="annualReportsInfo.assetsStatus">{{ annualReportsInfo.assetsStatus.netProfit }}</el-col>
              <el-col :span="7" class="col-2" v-else>-</el-col>
              <el-col :span="5" class="col-1">所有者权益合计</el-col>
              <el-col :span="7" class="col-2" v-if="annualReportsInfo.assetsStatus">{{ annualReportsInfo.assetsStatus.totalLiabilities }}</el-col>
              <el-col :span="7" class="col-2" v-else>-</el-col>
            </el-row>
            <el-row>
              <el-col :span="5" class="col-1">销售总额</el-col>
              <el-col :span="7" class="col-2" v-if="annualReportsInfo.assetsStatus">{{ annualReportsInfo.assetsStatus.totalSales }}</el-col>
              <el-col :span="7" class="col-2" v-else>-</el-col>
              <el-col :span="5" class="col-1">利润总额</el-col>
              <el-col :span="7" class="col-2" v-if="annualReportsInfo.assetsStatus">{{ annualReportsInfo.assetsStatus.totalProfit }}</el-col>
              <el-col :span="7" class="col-2" v-else>-</el-col>
            </el-row>
            <el-row>
              <el-col :span="5" class="col-1">营业总收入中主营业务收入</el-col>
              <el-col :span="7" class="col-2" v-if="annualReportsInfo.assetsStatus">{{ annualReportsInfo.assetsStatus.totalOwnerEquity }}</el-col>
              <el-col :span="7" class="col-2" v-else>-</el-col>
              <el-col :span="5" class="col-1">净利润</el-col>
              <el-col :span="7" class="col-2" v-if="annualReportsInfo.assetsStatus">{{ annualReportsInfo.assetsStatus.totalTaxPayment }}</el-col>
              <el-col :span="7" class="col-2" v-else>-</el-col>
            </el-row>
            <el-row>
              <el-col :span="5" class="col-1">纳税总额</el-col>
              <el-col :span="7" class="col-2" v-if="annualReportsInfo.assetsStatus">{{ annualReportsInfo.assetsStatus.totalAssets }}</el-col>
              <el-col :span="7" class="col-2" v-else>-</el-col>
              <el-col :span="5" class="col-1">负债总额</el-col>
              <el-col :span="7" class="col-2" v-if="annualReportsInfo.assetsStatus">{{ annualReportsInfo.assetsStatus.mainBusinessIncome }}</el-col>
              <el-col :span="7" class="col-2" v-else>-</el-col>
            </el-row>
          </div>
          <div class="col-i" v-else>
            <el-row>
              <el-col :span="24" class="col-2" style="text-align: center">暂无企业资产状况信息</el-col>
            </el-row>
          </div>
          <div class="cols-1" style="font-weight: bold;">修改事项</div>
          <div class="col-i">
            <el-table :data="annualReportsInfo.changeRecord" style="width: 100%" border
                      :header-row-style="{background:'#F3F9FC'}">
              <el-table-column type="index" label="序号" width="50" align="center"></el-table-column>
              <el-table-column prop="modifyDate" label="修改时间" align="center"></el-table-column>
              <el-table-column prop="matter" label="修改事项" align="center"></el-table-column>
              <el-table-column prop="modifyBefore" label="修改前" align="center"></el-table-column>
              <el-table-column prop="modifyAfter" label="修改后" align="center"></el-table-column>
            </el-table>
          </div>
          <div class="cols-1" style="font-weight: bold;">社保信息</div>
          <div class="col-i">
            <el-row>
              <el-col :span="5" class="col-1">城镇职工基本养老保险</el-col>
              <el-col :span="7" class="col-2">
                <span v-if="annualReportsInfo.socialSecurityInformation">
                  {{ annualReportsInfo.socialSecurityInformation.basicEndowmentInsurance || '' }}
                </span>
                <span v-else>-</span>
              </el-col>
              <el-col :span="5" class="col-1">职工基本医疗保险</el-col>
              <el-col :span="7" class="col-2">
                <span v-if="annualReportsInfo.socialSecurityInformation">
                  {{ annualReportsInfo.socialSecurityInformation.unemploymentInsurance || '' }}
                </span>
                <span v-else>-</span>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="5" class="col-1">生育保险</el-col>
              <el-col :span="7" class="col-2">
                <span v-if="annualReportsInfo.socialSecurityInformation">
                  {{ annualReportsInfo.socialSecurityInformation.basicMedicalInsuranceEmployees || '' }}
                </span>
                <span v-else>-</span>
              </el-col>
              <el-col :span="5" class="col-1">失业保险</el-col>
              <el-col :span="7" class="col-2">
                <span v-if="annualReportsInfo.socialSecurityInformation">
                  {{ annualReportsInfo.socialSecurityInformation.employmentInjuryInsurance || '' }}
                </span>
                <span v-else>-</span>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="5" class="col-1">工伤保险</el-col>
              <el-col :span="19" class="col-2">
                <span v-if="annualReportsInfo.socialSecurityInformation">
                  {{ annualReportsInfo.socialSecurityInformation.maternityInsurance || '' }}
                </span>
                <span v-else>-</span>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="5" class="col-1" :style="cheight">单位缴费基数</el-col>
              <el-col :span="19" class="cols-2" ref="taxbase" v-if="annualReportsInfo.socialSecurityInformation">
                <el-row v-for="unit of annualReportsInfo.socialSecurityInformation.unitPaymentBase">
                  <el-col :span="15" class="col-2">{{ unit.name }}</el-col>
                  <el-col :span="9" class="col-2">{{ unit.insurance }}</el-col>
                </el-row>
              </el-col>
              <el-col :span="19" class="cols-2" v-else style="text-align: center">-</el-col>
            </el-row>
            <el-row>
              <el-col :span="5" class="col-1" :style="Aheight">本期实际缴费金额</el-col>
              <el-col :span="19" class="cols-2" ref="payment" v-if="annualReportsInfo.socialSecurityInformation">
                <el-row v-for="payment of annualReportsInfo.socialSecurityInformation.actualPaymentAmountCurrentPeriod">
                  <el-col :span="15" class="col-2">{{ payment.name }}</el-col>
                  <el-col :span="9" class="col-2">{{ payment.insurance }}</el-col>
                </el-row>
              </el-col>
              <el-col :span="19" class="cols-2" v-else style="text-align: center">-</el-col>
            </el-row>
            <el-row>
              <el-col :span="5" class="col-1" :style="Bheight">单位累计欠缴金额</el-col>
              <el-col :span="19" class="cols-2" ref="amount" v-if="annualReportsInfo.socialSecurityInformation">
                <el-row v-for="arrears of annualReportsInfo.socialSecurityInformation.accumulatedUnpaidAmountCompany">
                  <el-col :span="15" class="col-2">{{ arrears.name }}</el-col>
                  <el-col :span="9" class="col-2">{{ arrears.insurance }}</el-col>
                </el-row>
              </el-col>
              <el-col :span="19" class="cols-2" v-else style="text-align: center">-</el-col>
            </el-row>
          </div>
        </el-row>
      </el-row>
    </div>
    <home_footer/>
    <Hang/>
  </div>
</template>
<script>
import Vue from 'vue';
import {annualReportRetails, getCompanyInfo} from '@/api/enterpriseDetailsApi';
import VXETable from 'vxe-table';
import HeaderIndex from "@/components/header/headerIndex";
import cityJson from "@/static/cityJson.json";
import Home_footer from "@/components/footer/home_footer";
import Hang from "@/components/Hang/Hangs";
Vue.use(VXETable)
export default {
  name: "annualReports",
  components: {Hang, Home_footer, HeaderIndex},
  data() {
    return {
      cheight: '',
      Aheight: '',
      Bheight: '',
      cityList:{},
      id: '',
      heightH: document.documentElement.clientHeight,
      heightL: 'auto',/*document.documentElement.clientHeight-130*/
      /*公司id*/
      corpId: 0,
      annualReportsInfo: {
        shareholderContributionInformation: [],
        essentialInformation: {
          creditCode: '',
          haveInvestmentInformationPurchase: '',
          address: '',
          websitesOnlineShop: '',
          email: '',
          practiceNumber: '',
          businessStatus: '',
          postalCode: '',
          contactNumber: '',
          companyName: ''
        },
        onlineShopWebsiteInformation: [],
        assetsStatus: {
          netProfit: '',
          totalLiabilities: '',
          totalSales: '',
          totalProfit: '',
          totalOwnerEquity: '',
          totalTaxPayment: '',
          totalAssets: '',
          mainBusinessIncome: ''
        },
        socialSecurityInformation: {
          basicEndowmentInsurance: '',
          unemploymentInsurance: '',
          basicMedicalInsuranceEmployees: '',
          employmentInjuryInsurance: '',
          maternityInsurance: '',
          unitPaymentBase: [],
          actualPaymentAmountCurrentPeriod: [],
          accumulatedUnpaidAmountCompany: [],

        },
        changeRecord: [],
      },
      basicInfo: {},
    }
  },
  computed: {
    logoword() {
      return function (word) {
        if (word)
          return word.split('');
        else
          return [];
      }
    }
  },
  methods: {
    /*随机生成颜色值*/
    createRandomColor() {
      let num = Math.floor(Math.random() * 9 + 1);
      let colorList = ['#7db3d9', '#d1ae9d', '#ca8484', '#bc9edd', '#8B658B', '#B22222', '#27408B', '#008B8B', '#5D478B', '#68228B'];
      console.log(colorList[num])
      return colorList[num];
    },
    /*获取公司基本信息*/
    getCompanyData() {
      getCompanyInfo({id: this.$route.query.corpId, request: 'form'}).then(res => {
        if (res.code == 200) {
          this.basicInfo = res.content;
        }
      })
    },
    /*获取企业年报详情*/
    getannualReport() {
      annualReportRetails({id: this.$route.query.id, request: 'form'}).then(res => {
        if (res.code == 200) {
          if (res.content != '' && res.content != undefined && res.content != null) {
            if (res.content.essentialInformation != null && res.content.essentialInformation != '' && res.content.essentialInformation != undefined) {
              res.content.essentialInformation = JSON.parse(res.content.essentialInformation.replace(/\'/g, '"'));
            }
            if (res.content.onlineShopWebsiteInformation != null && res.content.onlineShopWebsiteInformation != '' && res.content.onlineShopWebsiteInformation != undefined) {
              res.content.onlineShopWebsiteInformation = JSON.parse(res.content.onlineShopWebsiteInformation.replace(/\'/g, '"'))
            }
            if (res.content.shareholderContributionInformation != null && res.content.shareholderContributionInformation != '' && res.content.shareholderContributionInformation != undefined) {
              res.content.shareholderContributionInformation = JSON.parse(res.content.shareholderContributionInformation.replace(/\'/g, '"'));
            }
            if (res.content.assetsStatus != null && res.content.assetsStatus != '' && res.content.assetsStatus != undefined) {
              res.content.assetsStatus = JSON.parse(res.content.assetsStatus.replace(/\'/g, '"'));
            }
            if (res.content.changeRecord != null && res.content.changeRecord != '' && res.content.changeRecord != undefined) {
              res.content.changeRecord = JSON.parse(res.content.changeRecord.replace(/\'/g, '"'));
            }
            if (res.content.socialSecurityInformation != null && res.content.socialSecurityInformation != '' && res.content.socialSecurityInformation != undefined) {
              res.content.socialSecurityInformation = JSON.parse(res.content.socialSecurityInformation.replace(/\'/g, '"'));
              if (res.content.socialSecurityInformation.unitPaymentBase != '' && res.content.socialSecurityInformation.unitPaymentBase != null && res.content.socialSecurityInformation.unitPaymentBase != undefined) {
                let unitPaymentBase = res.content.socialSecurityInformation.unitPaymentBase;
                res.content.socialSecurityInformation.unitPaymentBase = [];
                for (let unit of unitPaymentBase){
                  let unitItem = unit.split(':');
                  res.content.socialSecurityInformation.unitPaymentBase.push({
                    name: unitItem[0], insurance: unitItem[1]
                  });
                }
              }
              if (res.content.socialSecurityInformation.actualPaymentAmountCurrentPeriod != '' && res.content.socialSecurityInformation.actualPaymentAmountCurrentPeriod != null && res.content.socialSecurityInformation.actualPaymentAmountCurrentPeriod != undefined) {
                let actualPaymentAmountCurrentPeriod = res.content.socialSecurityInformation.actualPaymentAmountCurrentPeriod;
                res.content.socialSecurityInformation.actualPaymentAmountCurrentPeriod = [];
                for(let actual of actualPaymentAmountCurrentPeriod){
                  let list = actual.split(':');
                  res.content.socialSecurityInformation.actualPaymentAmountCurrentPeriod.push({
                    name: list[0], insurance: list[1]
                  });
                }
              }
              if (res.content.socialSecurityInformation.accumulatedUnpaidAmountCompany != '' && res.content.socialSecurityInformation.accumulatedUnpaidAmountCompany != null && res.content.socialSecurityInformation.accumulatedUnpaidAmountCompany != undefined) {
                let accumulatedUnpaidAmountCompany = res.content.socialSecurityInformation.accumulatedUnpaidAmountCompany;
                res.content.socialSecurityInformation.accumulatedUnpaidAmountCompany = [];
                for(let list of accumulatedUnpaidAmountCompany){
                  let accumulated = list.split(':');
                  res.content.socialSecurityInformation.accumulatedUnpaidAmountCompany.push({
                    name: accumulated[0], insurance: accumulated[1]
                  })
                }
              }
            }
          }
          this.annualReportsInfo = res.content;
        }
      })
    },
    back(){
      window.history.back();
    }
  },
  mounted() {
    this.corpId=this.$route.query.corpId;
    this.id=this.$route.query.id;
    if (sessionStorage.getItem('setPositioning')) {
      this.cityList = JSON.parse(sessionStorage.getItem('setPositioning'));
    } else {
      let cityList = JSON.parse(sessionStorage.getItem('locationInfo'));
      for (let li of cityJson) {
        if (cityList.short_name == li.short_name)
          this.cityList = li;
      }
    }
    this.getannualReport();
    this.getCompanyData();
    setTimeout(() => {
      this.cheight = 'height:' + this.$refs.taxbase.$el.offsetHeight + 'px;line-height:' + this.$refs.taxbase.$el.offsetHeight + 'px;';
      this.Aheight = 'height:' + this.$refs.payment.$el.offsetHeight + 'px;line-height:' + this.$refs.payment.$el.offsetHeight + 'px;';
      this.Bheight = 'height:' + this.$refs.amount.$el.offsetHeight + 'px;line-height:' + this.$refs.amount.$el.offsetHeight + 'px;';
    }, 100);
  }
}
</script>
<style scoped>
.annualReport >>> .basic-content .basic-details-breadcrumb .el-breadcrumb__separator[class*=icon] {
  margin: 0 0px;
  font-family: 'SourceHanSansCN';
  color: #666666;
}
.annualReport >>> .basic-content .basic-details-breadcrumb .el-breadcrumb__item:last-child .el-breadcrumb__inner,
.annualReport >>> .basic-content .basic-details-breadcrumb .el-breadcrumb__item:last-child .el-breadcrumb__inner a,
.annualReport >>> .basic-content .basic-details-breadcrumb .el-breadcrumb__item:last-child .el-breadcrumb__inner a:hover,
.annualReport >>> .basic-content .basic-details-breadcrumb .el-breadcrumb__item:last-child .el-breadcrumb__inner:hover {
  font-weight: 100;
  color: #666666;
  font-family: 'SourceHanSansCN';
}
.annualReport >>> .basic-content .basic-details-breadcrumb .el-breadcrumb {
  font-size: 14px;
  line-height: normal;
}
.annualReport >>> .basic-content .basic-details-breadcrumb .el-breadcrumb__inner a,
.annualReport >>> .basic-content .basic-details-breadcrumb .el-breadcrumb__inner.is-link {
  font-weight: 100;
  color: #666666;
  font-family: 'SourceHanSansCN';
}

.annualReport >>> .el-table td.el-table__cell, .el-table th.el-table__cell.is-leaf {
  background: center;
  color: #333333;
}
/*自定义表格头样式*/
.annualReport >>> .el-tabs--border-card > .el-tabs__header .el-tabs__item.is-active {
  color: #409EFF;
  background-color: #FFF;
  border-right-color: white !important;
  border-left-color: white !important;
  border-bottom-color: #FCFCFC !important;
  border-top: 4px solid;
}
.annualReport >>> .el-tabs__item {
  padding: 0 30px !important;
  height: 60px !important;
  line-height: 60px !important;
  font-weight: bold !important;
}
.annualReport >>> .el-tabs--border-card > .el-tabs__header .el-tabs__item {
  border-left: none !important;
  border-bottom: none !important;
}
.annualReport >>> .vxe-table--render-default .vxe-body--column:not(.col--ellipsis), .vxe-table--render-default .vxe-footer--column:not(.col--ellipsis), .vxe-table--render-default .vxe-header--column:not(.col--ellipsis) {
  padding: 10px 0 !important;
}
.annualReport >>> .el-avatar > img {
  display: block;
  height: 100%;
  width: 100%;
  vertical-align: middle;
}
.annualReport >>> .el-avatar {
  background: white;
  border: 1px solid rgba(0,0,0,.05);
  border-radius: 4px;
}
.annualReport >>> .vxe-table .vxe-table--header-wrapper {
  color: #333333;
  background: #F3F9FC;
}
.annualReport >>> .vxe-table--render-default {
  color: #333333;
}

.annualReport >>> .el-breadcrumb__separator[class*=icon] {
  margin: 0 0px !important;
  font-weight: 400;
}

.annualReport >>> .el-tabs__item {
  padding: 0 30px !important;
  height: 60px !important;
  line-height: 60px !important;
  font-weight: bold !important;
}
.annualReport >>> .el-table th.el-table__cell {
  background: #F3F9FC;
  color: #333333;
}
</style>
<style scoped lang="scss">
.annualReport {
  background: #ECEEF5;
  /*头部条样式*/
  .container-header {
    background: #081961;
    padding: 20px 18%;
    color: white;
    font-size: 16px;
    font-weight: bold;
  }

  /*企业基本信息css样式*/
  .basic-content {
    padding: 10px 18%;
    background: #ECEEF5;
    min-width: 76rem;
    .basic-details {
      margin-top: 10px;
      .logo-keyword {
        height: 170px;
        width: 170px;
        font-size: 48px;
        color: #ffffff;
        font-weight: 500;
        display: flex;
        flex-wrap: wrap;
        align-items: center;
        justify-content: center;
        margin: 0px;

        .logo-word {
          width: 34%;
          height: 34%;
          display: flex;
          align-items: center;
          justify-content: center;
        }
      }
    }
    /*.basic-details::-webkit-scrollbar {
      width: 4px;
    }

    .basic-details::-webkit-scrollbar-thumb {
      height: 8px;
      border-radius: 8px;
      background-color: #999999;
    }*/
  }
  .userName {
    font-size: 20pt;
    color: #333333;
    margin-top: 25px;
    font-weight: bold;
  }
  .small-info {
    padding-top: 5px;
    color: #333333;
  }
  .cols-1 {
    height: 60px;
    line-height: 60px;
    padding-left: 30px;
    font-size: 18px;
    color: #333333;
  }
  .col-i {
    margin-left: 30px;
    margin-top: 10px;
    margin-right: 30px;
    margin-bottom: 20px;
  }
  .col-1 {
    padding: 20px 10px;
    background: #F3F9FC;
    border: 0.5pt solid #e5eef6;
    text-align: left;
    padding-left: 30px;
  }
  .col-2 {
    padding: 20px 10px;
    background: #ffffff;
    border: 0.5pt solid #e5eef6;
    text-align: left;
  }
  .col-4 {
    padding: 20px 10px !important;
    background: #F3F9FC;
    border: 0.5pt solid #e5eef6;
    padding-left: 30px;
    text-align: center;
  }
  .col-3 {
    padding: 20px 10px;
    background: #ffffff;
    border: 0.5pt solid #e5eef6;
    text-align: center;
  }
}
</style>